import { configureStore } from "@reduxjs/toolkit";

//import authReducer from "../features/auth/authSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import userReducer from "../features/users/userSlice";
import bankReducer from "../features/banks/bankSlice";
import buyerReducer from "../features/buyers/buyerSlice";
import despatchoReducer from "../features/despatcho/despatchoSlice";
import portReducer from "../features/ports/portSlice";
import redexReducer from "../features/redex/redexSlice";
import shippingReducer from "../features/shipping/shippingSlice";
import supplierReducer from "../features/supplier/supplierSlice";
import transporterReducer from "../features/transporter/transporterSlice";
import ledgerReducer from "../features/ledgers/ledgerSlice";
import materialReducer from "../features/materials/materialSlice";

export const store = configureStore({
    reducer: {
        //auth: authReducer,
        dashboard: dashboardReducer,
		users: userReducer,
        banks: bankReducer,
		buyers: buyerReducer,
		despatcho: despatchoReducer,
		ports: portReducer,
		redex: redexReducer,
		shipping: shippingReducer,
		supplier: supplierReducer,
		transporter: transporterReducer,
		ledgers: ledgerReducer,
		materials: materialReducer
    }
});